import { render, staticRenderFns } from "./StatusChanger.vue?vue&type=template&id=72831c42&scoped=true"
import script from "./StatusChanger.vue?vue&type=script&lang=js"
export * from "./StatusChanger.vue?vue&type=script&lang=js"
import style0 from "./StatusChanger.vue?vue&type=style&index=0&id=72831c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72831c42",
  null
  
)

export default component.exports